"use client";
import { PropsWithChildren, useState } from "react";
import { BlogSearch } from "components/pages/blog/search/BlogSearch";
import { TaxonomiesList, TaxonomiesListItem } from "components/pages/blog/search/TaxonomiesList";
import { LoadingSpinnerWrapper } from "components/UI/LoadingSpinnerWrapper";
import useTranslationsSearch from "helpers/blog/useTranslationsSearch";
import { BlogSearchArticlesFn, SearchFilterEntity } from "@/helpers/blog/useBlogSearch";
import { ArticlesList } from "@/components/pages/blog/search/ArticlesList";
import { ArticleListItemData } from "@/types/strapi/article";
import { BlogPaginationProps } from "@/components/pages/blog/BlogPagination";

const initialPage = 1;
const articlesPerPage = 24;

type SearchEngineProps = {
  listClassName?: string;
  taxonomyHeading?: string;
  showSubcategory?: boolean;
  isSearch: boolean;
  isLoading: boolean;
  filteredArticles: ArticleListItemData[];
  taxonomies?: TaxonomiesListItem[];
  pagination: BlogPaginationProps;
};

export const TSearchEngine = ({
  children,
  taxonomies,
  listClassName,
  taxonomyHeading = "Categories",
  showSubcategory,
  pagination,
  isSearch,
  isLoading,
  filteredArticles,
}: PropsWithChildren<SearchEngineProps>) => {
  return (
    <>
      {taxonomies && !!taxonomies.length && <TaxonomiesList list={taxonomies} heading={taxonomyHeading} />}
      {!isSearch && children}
      {isSearch && (
        <LoadingSpinnerWrapper isLoading={isLoading}>
          <ArticlesList
            list={filteredArticles}
            className={listClassName}
            showSubcategory={showSubcategory}
            pagination={pagination}
            urlPrefix="/translations"
          />
        </LoadingSpinnerWrapper>
      )}
    </>
  );
};
